import Vue from 'vue';

export function brandRecommendOfPieChart(data) {
  return Vue.axios({
    url: `/dashBoard/brandRecommendOfPieChart`,
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_BASE_API
  })
}

export function brandRecommendSingle(data) {
  return Vue.axios({
    url: `/dashBoard/brandRecommendSingle`,
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_BASE_API
  })
}

export function listBrandRecommend(data) {
  return Vue.axios({
    url: `/dashBoard/listBrandRecommend`,
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_BASE_API
  })
}
